export default "__VITE_ASSET__CGfh4Q9g__"